export const FormIdentifiers = Object.freeze({
  Project: 'Project',
  ProjectIssue: 'ProjectIssue',
  ProjectReceipt: 'ProjectReceipt',
  ResourceOne: 'ResourceOne',
  SimpleTask: 'SimpleTask',
  SapShiftLeaderReport: 'SapShiftLeaderReport',
  SourceList: 'SourceList',
  VatCode: 'VatCode',
  Country: 'Country',
  Currency: 'Currency',
  Language: 'Language',
  SupplierComplaint: 'SupplierComplaint',
  MaterialPlan: 'MaterialPlan',
  ServiceIssue: 'ServiceIssue',
  ServiceReceipt: 'ServiceReceipt',
  DeliveryDraft: 'DeliveryDraft',
  ServiceMonitor: 'ServiceMonitor',
  ProductionMaterial: 'ProductionMaterial',
  InventoryTransfer: 'InventoryTransfer',
  InventoryTransferDoc: 'InventoryTransferDoc',
  PurchaseDelivery: 'PurchaseDelivery',
});
